import { render, staticRenderFns } from "./TimepointGroup.vue?vue&type=template&id=618d71d4&"
import script from "./TimepointGroup.vue?vue&type=script&lang=js&"
export * from "./TimepointGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports